import { render, staticRenderFns } from "./shopDataDaily.vue?vue&type=template&id=12271362&scoped=true"
import script from "./shopDataDaily.vue?vue&type=script&lang=js"
export * from "./shopDataDaily.vue?vue&type=script&lang=js"
import style0 from "./shopDataDaily.vue?vue&type=style&index=0&id=12271362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12271362",
  null
  
)

export default component.exports